<template>
	<label :for="forText"
		>{{ label }}
		<span v-if="helpText" class="icg-calc__help">
			<span class="icg-calc__help-text">{{ helpText }}</span>
		</span>
	</label>
</template>

<script>
export default {
	data() {
		return {
			for: null
		};
	},

	props: {
		forText: {
			type: String,
			required: true
		},

		helpText: {
			type: String
		},

		label: {
			type: String,
			required: true
		}
	}
};
</script>
